export default function FinalCtaSection() {
  return (
    <section className="py-14 md:py-20 bg-graphite">
      <div className="container-main px-4 md:px-8 lg:px-12 text-center">
        <span className="tag-label bg-white/10 text-cream border-white/20 mb-4 inline-block">
          立即行動
        </span>
        <h2 className="text-cream mb-4">
          預製工法適合你的基地嗎？<br className="hidden md:block" />
          預約 90 分鐘說明會，讓專家幫你評估
        </h2>
        <p className="text-cream/70 text-base max-w-2xl mx-auto mb-8 leading-relaxed">
          我們會根據你的基地條件、預算、時程與需求，客觀建議最適合的工法與規劃方向。
          無論最後選擇預製鋼構或傳統 RC，我們都會給你專業的建議。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 flex-wrap">
          <a
            href="https://lin.ee/OpssTIM"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-champagne text-graphite font-semibold text-base hover:bg-champagne/90 transition-all duration-300 whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-line-fill" />
            </span>
            預約工法說明會
          </a>
          <a
            href="/process"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-cream/40 text-cream font-semibold text-base hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-file-list-3-line" />
            </span>
            了解完整服務流程
          </a>
          <a
            href="/process"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-champagne/40 text-champagne font-semibold text-base hover:bg-champagne/10 transition-all duration-300 whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-calculator-line" />
            </span>
            立即試算預算
          </a>
        </div>
      </div>
    </section>
  );
}